import { API_BASE_URL } from "src/config/api";
import React, { useCallback, useState, useEffect } from 'react';
import { Card, CardContent, Typography, Grid, Stack, Box, CardHeader } from '@mui/material';
import { FaGlobe } from 'react-icons/fa';
import axios from 'axios';
import { alpha, useTheme } from '@mui/material/styles';
import { Colors } from '../../../landingPage/style/theme';
import Iconify from '../../../components/iconify';

const StatusBox = ({ label, up, down, used, total, iconFor }) => {
    const theme = useTheme();
    return (
        <Box
            sx={{
                p: 4,
                borderRadius: 2,
                border: '1px solid #e0e0e0',
                backgroundColor:
                    theme.palette.mode === 'light'
                        ? alpha(theme.palette.grey[200], 0.9)
                        : alpha(theme.palette.background.paper, 0.4),
                textAlign: 'center',
                maxHeight: '247px',
            }}
        >
            {/* Icons above the label */}
            <Stack direction="row" spacing={1} justifyContent="center" mb={2}>
                {iconFor === 'node' ? <Iconify color={Colors.primary} icon="ic:baseline-analytics" width={35} height={35} /> : <FaGlobe color={Colors.primary} size={28} />}
            </Stack>

            <Typography variant="subtitle1" fontWeight="600" gutterBottom>
                {label}
            </Typography>

            <Stack direction="row" justifyContent="center" spacing={8} alignItems="center" mt={1}>
                {/* Up Box */}
                <Box textAlign="center">
                    <Stack direction="row" alignItems="center" justifyContent="center" spacing={0.5} mb={0.5}>
                        {/* <ArrowDropUp color="success" /> */}
                        <Typography variant="h4" fontWeight="bold" color="success.dark">
                            {up}
                        </Typography>
                    </Stack>
                    <Typography variant="body1" color="text.primary">
                        Up
                    </Typography>
                </Box>

                {/* Down Box */}
                <Box textAlign="center">
                    <Stack direction="row" alignItems="center" justifyContent="center" spacing={0.5} mb={0.5}>
                        {/* <ArrowDropDown color="error" /> */}
                        <Typography variant="h4" fontWeight="bold" color="error.main">
                            {down}
                        </Typography>
                    </Stack>
                    <Typography variant="body1" color="text.primary">
                        Down
                    </Typography>
                </Box>

            </Stack>


            <Typography variant="body1" color="text.secondary" mt={2}>
                {iconFor === 'node' ? `Using ${used} of ${total} node monitors` : `Using ${used} of ${total} domain monitors`}

            </Typography>
        </Box>
    );
};

const StatusOverview = () => {
    const token = localStorage.getItem('token');
    const [runningPlan, setRunningPlan] = useState(null);

    const fetchPlan = useCallback(async () => {
        try {
            const cleanToken = token.replace(/"/g, '');
            const config = {
                headers: {
                    Authorization: `Bearer ${cleanToken}`,
                },
            };

            const response = await axios.get(`${API_BASE_URL}/userPlanOverview`, config);

            if (response.data && response.data.data) {
                const plans = Object.entries(response.data.data).map(([id, plan]) => ({
                    id,
                    ...plan,
                }));
                const activePlan = plans.length > 0 ? plans[0] : null;
                setRunningPlan(activePlan || null);
            } else {
                setRunningPlan(null);
            }
        } catch (error) {
            console.error('Error fetching running plan:', error);
        }
    }, [token]);

    useEffect(() => {
        fetchPlan();
    }, [fetchPlan]);


    return (
        <Card sx={{ width: '100%', minHeight: { xs: 'auto', md: '380px' } }}>
            <CardHeader
                title="Uptime & Downtime Metrics"
                subheader="Current Monitoring Status of Nodes and Domains"
            />

            <CardContent>
                <Grid container spacing={3}>
                    <Grid item xs={12} md={6}>
                        <StatusBox
                            label="Node Status"
                            up={runningPlan?.ipStatus?.up || 0}
                            down={runningPlan?.ipStatus?.down || 0}
                            used={runningPlan?.totalIpCount - runningPlan?.ipCount || 0}
                            total={runningPlan?.totalIpCount || 0}
                            iconFor="node"
                        />
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <StatusBox
                            label="Domain Status"
                            up={runningPlan?.domainStatus?.up || 0}
                            down={runningPlan?.domainStatus?.down || 0}
                            used={runningPlan?.totalDomainCount - runningPlan?.domainCount || 0}
                            total={runningPlan?.totalDomainCount || 0}
                            iconFor="domain"
                        />
                    </Grid>
                </Grid>

            </CardContent>
        </Card>
    );
};

export default StatusOverview;
